import { LayoutDashboard, ClipboardList, Truck, Receipt, Package, PackagePlus, Gift, AlertTriangle, MapPinned, Users, BarChart3, Shield, Building2 } from 'lucide-react';
import { AppSwitcher, Sidebar as OsSidebar, SidebarUser, type NavItem } from '@os/ui';
import { useOsAuth } from '@os/auth-client/react';
import { useMe, useSidebarCounts } from '@/services/api';
import { APP_ID, OS_URL } from '@/app/auth';
import { APP_NAV } from './appNav';
import { BRAND } from './AppShell';

/** Groups and screens from the design (§4): Overview · Daily operations · Stock · Network · Reports · Admin, then the OS App group. */
const NAV: NavItem[] = [
  { group: 'Overview' },
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { group: 'Daily operations' },
  { to: '/entry', label: 'Daily sales entry', icon: ClipboardList, badge: 'orders' },
  { to: '/dispatch', label: 'Dispatch & loading', icon: Truck, badge: 'sheets' },
  { to: '/invoices', label: 'Invoices', icon: Receipt, badge: 'unpaid' },
  { group: 'Stock' },
  { to: '/products', label: 'Products', icon: Package },
  { to: '/purchases', label: 'Purchases / GRN', icon: PackagePlus },
  { to: '/free', label: 'Free issues', icon: Gift },
  { to: '/damage', label: 'Damage & claims', icon: AlertTriangle, badge: 'claims' },
  { group: 'Network' },
  { to: '/network', label: 'Routes & outlets', icon: MapPinned },
  { to: '/salesmen', label: 'Salesmen & targets', icon: Users },
  { group: 'Reports' },
  { to: '/reports', label: 'Report suite', icon: BarChart3 },
  { group: 'Admin' },
  { to: '/users', label: 'Users & roles', icon: Shield },
  { to: '/company', label: 'Company profile', icon: Building2 },
  ...APP_NAV,
];

const ROLE_LABEL: Record<string, string> = { owner: 'Owner', manager: 'Manager', storekeeper: 'Storekeeper', salesman: 'Salesman' };

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  const { data } = useMe();
  const counts = useSidebarCounts();
  const auth = useOsAuth();
  const apps = [
    { id: 'os', name: 'OS', url: OS_URL, icon: 'OS' },
    ...(auth.getClaims()?.apps ?? []).filter((a) => a.id !== 'os' && a.id !== APP_ID).map((a) => ({ id: a.id, name: a.id, url: OS_URL })),
  ];
  return (
    <OsSidebar brand={BRAND} nav={NAV} badges={counts} onNavigate={onNavigate} footer={
      <>
        <div style={{ fontSize: 11, color: 'var(--text-3)', letterSpacing: '.04em' }}>Stationery · DC-01</div>
        <SidebarUser name={data?.user.display_name ?? '…'} subtitle={(data?.roles ?? []).map((r) => ROLE_LABEL[r] ?? r).join(', ') || 'Signing in'} />
        <AppSwitcher apps={apps} currentAppId={APP_ID} osUrl={OS_URL} logoutHref={`${auth.options.issuer}/logout?post_logout_redirect_uri=${encodeURIComponent(OS_URL)}`} onLogout={() => auth.logout(OS_URL)} />
      </>
    } />
  );
}
